import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue'),
    meta: {
      title: 'Home Page - 20 Minutes of Innovation',
      description: 'Welcome to 20 Minutes of Innovation Volume 8 (20moi vol.8) by Euroavia Patras. Discover cutting-edge innovations and connect with industry leaders at this dynamic one-day conference.',
      keywords: '20 Minutes of Innovation, 20moi vol.8, Innovation, Conference, Euroavia Patras, Technology'
    }
  },
  {
    path: '/info',
    name: 'info',
    component: () => import(/* webpackChunkName: "about" */ '../views/InfoView.vue'),
    meta: {
      title: 'Info Page - 20 Minutes of Innovation',
      description: 'Learn about 20 Minutes of Innovation Volume 8, a one-day conference by Euroavia Patras. Explore the latest trends in innovation with experts from various fields. Join us for insightful talks and networking opportunities.',
      keywords: 'Innovation, Conference, Euroavia Patras, 20 Minutes of Innovation, Technology, Expert Talks, Networking'
    }
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '../views/ScheduleView.vue'),
    meta: {
      title: 'Schedule Page - 20 Minutes of Innovation',
      description: 'Explore the 20moi vol.8 conference schedule. Plan your day with expert talks, workshops, and panel discussions covering the latest in technology and innovation.',
      keywords: 'Conference Schedule, 20moi vol.8, Innovation, Technology, Expert Talks, Workshops, Panel Discussions'
    }
  },
  {
    path: '/speakers',
    name: 'speakers',
    component: () => import(/* webpackChunkName: "speakers" */ '../views/SpeakersView.vue'),
    meta: {
      title: 'Speakers Page - 20 Minutes of Innovation',
      description: 'Meet the speakers of 20moi vol.8! Discover innovators and thought leaders presenting at this year’s conference, hosted by Euroavia Patras.',
      keywords: 'Speakers, 20moi vol.8, Innovation Leaders, Conference, Euroavia Patras'
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "feedback" */ '../views/FeedbackView.vue'),
    meta: {
      title: 'Feedback Page - 20 Minutes of Innovation',
      description: 'Share your thoughts on 20 Minutes of Innovation Volume 8 (20moi vol.8). Provide feedback on event organization, speakers, and innovation topics to help us improve future conferences by Euroavia Patras.',
      keywords: 'Feedback, 20moi vol.8, 20 Minutes of Innovation, Conference Feedback, Euroavia Patras, Event Organization, Innovation Topics, Speakers Feedback'
    }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: () => import(/* webpackChunkName: "gallery" */ '../views/GalleryView.vue'),
    meta: {
      title: 'Gallery Page - 20 Minutes of Innovation',
      description: 'Relive the highlights of 20moi vol.8 with our photo and video gallery. Browse moments from the one-day innovation conference organized by Euroavia Patras.',
      keywords: 'Gallery, 20moi vol.8, Innovation, Euroavia Patras, Conference Highlights, Photos, Videos'
    }
  },
  {
    path: '/staytuned',
    name: 'staytuned',
    component: () => import(/* webpackChunkName: "gallery" */ '../views/StayTunedView.vue'),
    meta: {
      title: 'Stay Tuned Page - 20 Minutes of Innovation',
      description: 'Relive the highlights of 20moi vol.8 with our photo and video gallery. Browse moments from the one-day innovation conference organized by Euroavia Patras.',
      keywords: 'Gallery, 20moi vol.8, Innovation, Euroavia Patras, Conference Highlights, Photos, Videos'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // Scroll to top when navigating to a new page
    return { top: 0 }; 
  }
})

export default router
